module.exports = __webpack_public_path__ + "static/thumbs-d3356bfc48940430103a927c13a7f11c.svg";